/** @jsx jsx */
import {
  Box,
  Flex,
  Button,
  CloseIcon,
  Title,
  InfoIcon,
  Text,
} from '@bottlebooks/gatsby-theme-base';
import { Plural } from '@lingui/macro';
import Dialog from '@reach/dialog';
import { useState } from 'react';
import { jsx } from 'theme-ui';
import DefaultFacet from '../DefaultFacet/DefaultFacet';

export default function ProductPriceRangeFacet({
  allValues,
  selectedValues,
  onToggle,
  totalCount,
  count,
  event,
  ...rest
}) {
  const [isVisible, toggleVisible] = useState(false);
  return (
    <DefaultFacet
      multiSelect
      title={
        <Text>
          <Plural
            value={allValues?.length}
            one="# price range"
            other="# price ranges"
          />
          <Button
            variant="text"
            onClick={() => {
              toggleVisible(!isVisible);
            }}
          >
            <InfoIcon sx={{ marginTop: -1, marginLeft: 1 }} size="small" />
          </Button>
          {isVisible && (
            <Dialog
              isOpen
              aria-label="Price range"
              sx={{
                borderRadius: 'default',
                '&&': {
                  width: ['100vw', '100vw', '75vw', 768],
                  padding: 2,
                },
              }}
              onDismiss={() => toggleVisible(false)}
            >
              <Flex justify="space-between" sx={{ marginBottom: 3 }}>
                <Title variant="small">Price range overview</Title>
                <Button onClick={() => toggleVisible(false)}>
                  <CloseIcon />
                </Button>
              </Flex>
              <Flex direction="column" align="center" sx={{ marginY: 4 }}>
                <Box>
                  <img
                    alt="Price range details"
                    srcSet={
                      event.pricing?.publicPriceRangeImage?.fixed.srcSet ||
                      event.pricing?.priceRangeImage?.fixed.srcSet
                    }
                    sx={{ maxWidth: '100%' }} // Prevent from running off mobile devices
                  />
                </Box>
              </Flex>
            </Dialog>
          )}
        </Text>
      }
      allValues={allValues?.map((range) => ({
        ...range,
        label: range.value,
      }))}
      selectedValues={selectedValues}
      onToggle={onToggle}
      totalCount={totalCount}
      count={count}
      {...rest}
    />
  );
}
